export default {
  title: {
    en: 'Dear {userName},',
  },
  text: {
    en: 'we want to say thanks for trying Scentbird. We are a small business, and your feedback means a lot to us.',
  },
  teamLabel: {
    en: 'Team Scentbird',
  },
  reasonsTitle: {
    en: 'Please let us know the reason you are cancelling.',
  },
  reasonMessagePlaceholder: {
    en: 'Please let us know why you are cancelling',
  },
  reasonMessageRequired: {
    en: 'You have to write a comment in order to cancel the subscription',
  },
  cancelSubscription: {
    en: 'Cancel subscription',
  },
  or: {
    en: 'or',
  },
  neverMind: {
    en: 'Never mind',
  },
}
